import { ICellRendererParams } from 'ag-grid-community';
import { Component, Input, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  SharedRecipient,
  SharedRecipientDetails,
} from '@compumark/order-management-client';

import { OrderSharingModalComponent } from '../../../sharing/components/order-sharing-modal/order-sharing-modal.component';

@Component({
  selector: 'app-share-order',
  templateUrl: './share-order.component.html',
  styleUrls: ['./share-order.component.scss'],
  standalone: false,
})
export class ShareOrderComponent implements OnInit {
  private dialog = inject(MatDialog);

  @Input() sharedRecipientDetails!: SharedRecipientDetails[];
  @Input() params!: ICellRendererParams;

  protected contactsCount!: number;
  protected isOrderShared!: boolean;

  ngOnInit(): void {
    this.validateInput();
    if (!this.isOrderShared) {
      return;
    }
    this.contactsCount =
      this.sharedRecipientDetails
        ?.flatMap((details: SharedRecipientDetails) => details.sharedTo ?? [])
        .flatMap((recipient: SharedRecipient) => recipient.contacts ?? [])
        .length ?? 0;
  }

  private validateInput(): void {
    const list = this.sharedRecipientDetails;

    this.isOrderShared =
      Array.isArray(list) &&
      list.length > 0 &&
      list.some(
        (details) =>
          !!details?.sharedBy &&
          !!details?.dateShared &&
          (details?.sharedTo?.length ?? 0) > 0,
      );
  }

  protected openOrderSharingModalWindow(): void {
    this.dialog.open(OrderSharingModalComponent, {
      data: {
        rowNode: this.params.node,
        rowData: this.params.data,
        sharedRecipientDetails: this.sharedRecipientDetails,
      },
      width: '65vw',
      height: '90vh',
      disableClose: true,
    });
  }
}
